// extracted by mini-css-extract-plugin
export default {"wrap":"oJ-z","fullWidth":"pJ-z","hideOnDesktop":"qJ-z","content":"rJ-z","hasOpenedNav":"sJ-z","crumbsList":"tJ-z","dropdownsWrap":"uJ-z"};